"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = void 0;
var Device;
(function (Device) {
    Device["DESKTOP"] = "desktop";
    Device["MOBILE"] = "mobile";
    Device["TABLET"] = "tablet";
})(Device || (exports.Device = Device = {}));
//# sourceMappingURL=types.js.map